export default {
  // Function to fetch cookie name
  getCookieName (ctoken) {
    const name = `${ctoken}=`
    const decodedCookie = decodeURIComponent(document.cookie)
    const ca = decodedCookie.split(';')
    for (let i = 0; i < ca.length; i += 1) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1)
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length)
      }
    }
    return null
  },

  setCookie (ncname, ncvalue, ncexpiry) {
    document.cookie = `${ncname}=${ncvalue}; expires=${ncexpiry.toGMTString()}`
  },

  checkCookie (cname) {
    return this.getCookieName(cname) !== null
  },

  removeCookie (ncname) {
    document.cookie = `${ncname}=''; expires=Thu, 01 Jan 1970 00:00:01 GMT;`
  }
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js